import React from 'react';
import { connect } from 'react-redux';

import { Modal, Select } from 'redpoints-front-components/index';

import { reportedIncidentsSetDiscardReason } from '../../../actions/reportedIncidentsActions';
import {
  getReportedIncidentsDiscardReasons,
  getReportedIncidentsDiscardReasonsIsLoading,
  getReportedIncidentsSelectedDiscardReason,
} from '../../../reducers/tasks/reportedIncidents';
import { translate } from '../../../helpers/languageHelper';

const ReportedIncidentsDiscardReasonModal = ({
  isModalVisible,
  handleOnCancel,
  handleOnOk,
  discardReasons,
  reportedIncidentsSetDiscardReason,
  isLoadingDiscardReasons,
  selectedDiscardReason,
}) => {
  const handleOnChange = discardReasonId => {
    reportedIncidentsSetDiscardReason({ discardReasonId });
  };

  const isDisabledOkButton = !selectedDiscardReason;

  return (
    <Modal
      title={translate('tasks.reported_incidents.discardReasonModal.title')}
      visible={isModalVisible}
      onCancel={handleOnCancel}
      onOk={handleOnOk}
      okButtonProps={{
        disabled: isDisabledOkButton,
      }}
      okText={translate('tasks.reported_incidents.discardReasonModal.confirm')}
    >
      <Select
        data={discardReasons}
        label={translate(
          'tasks.reported_incidents.discardReasonModal.reasonLabel'
        )}
        mapping={{ key: 'incidentDiscardedReasonId', value: 'name' }}
        placeholder={translate(
          'tasks.reported_incidents.discardReasonModal.reasonPlaceholder'
        )}
        onChange={handleOnChange}
        value={selectedDiscardReason?.incidentDiscardedReasonId}
        loading={isLoadingDiscardReasons}
      />
    </Modal>
  );
};

const mapStateToProps = state => ({
  discardReasons: getReportedIncidentsDiscardReasons(state),
  isLoadingDiscardReasons: getReportedIncidentsDiscardReasonsIsLoading(state),
  selectedDiscardReason: getReportedIncidentsSelectedDiscardReason(state),
});

export default connect(mapStateToProps, { reportedIncidentsSetDiscardReason })(
  ReportedIncidentsDiscardReasonModal
);
